import _ from 'lodash';

export default {
    data() {
        return {
            rules: {
                required: v => !!v || 'Поле обязательно для заполнения',
                requiredTrim: v => !!(v || "").toString().trim() || 'Поле обязательно для заполнения',
                requiredNumber: v => (v != null && v.toString().trim() !== '' && _.isFinite(+v)) || 'Необходимо указать числовое значение',
                positiveNumber:  v => (v != null && v.toString().trim() !== '' && _.isFinite(+v) && +v > 0) || 'Необходимо указать положительное число',
                nonNegativeInteger: v => (v != null && v.toString().trim() !== '' && _.isInteger(+v) && +v >= 0) || 'Необходимо указать целое неотрицательное число',
                numberOfRange: (min, max) => v => v != null && v.toString().trim() !== '' && _.isFinite(+v) && +v >= min && +v <= max || `...в диапазоне (${min}–${max})`,
                minLength: (minLength) => v => (v || "").toString().trim().length >= minLength || `Не менее ${minLength} символов`,
                minPasswordLength: (minLength) => v => !v || (v || "").toString().length >= minLength || `Не менее ${minLength} символов`,
                color: v => v && CSS.supports("color", v) || "Введите корректный цвет (HEX, RGB, название цвета)",
            }
        }
    }
}